import { css } from '@emotion/react'
import React from 'react'
import { Box, Container, Grid, useMediaQuery } from '@material-ui/core'
import { withThemeProps } from '@findep/microfronts-core'
import GreenCard from './formCard'
import HeroImage from '../../images/afi/redfam.png'
import SecurityOutlinedIcon from '@material-ui/icons/SecurityOutlined'

const pageCss = css`
    background: #fafaf8;

    padding: 0;
    margin-bottom: 0;

    width: 100%;
    max-width: 100vw;

`

const heroCss = css`
    position: relative;
    border-radius: 0;
    padding: 40px 32px 0;
    background: #fafaf8;

    @media (max-width: 959px) {
        min-height: auto;
        padding: 24px 18px 0;
        overflow-x: clip;
    }
`

const glowTopCss = css`
    position: absolute;
    top: -100px;
    right: 0;
    width: 600px;
    height: 600px;
    border-radius: 300px;
    background: radial-gradient(50% 50% at 50% 50%, rgba(27, 107, 74, 0.07) 0%, rgba(27, 107, 74, 0) 70%);
    pointer-events: none;

    @media (max-width: 959px) {
        display: none;
    }
`

const glowBottomCss = css`
    position: absolute;
    left: 20%;
    bottom: -80px;
    width: 400px;
    height: 400px;
    border-radius: 200px;
    background: radial-gradient(50% 50% at 50% 50%, rgba(200, 151, 58, 0.06) 0%, rgba(200, 151, 58, 0) 70%);
    pointer-events: none;

    @media (max-width: 959px) {
        display: none;
    }
`

const titleCss = css`
    margin: 0 0 12px;
    max-width: 771px;
    color: #3d3d3d;
    font-family: 'Jost', 'Helvetica Neue', Arial, sans-serif;
    font-size: 54.4px;
    line-height: 62.56px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: -0.5px;
    vertical-align: middle;

    @media (max-width: 959px) {
        max-width: none;
        font-size: 32px;
        line-height: 1.2;
        margin-bottom: 10px;
    }
`

const accentCss = css`
    color: #ff7a45;
`

const subtitleCss = css`
    margin: 0 0 20px;
    max-width: 620px;
    color: #747b84;
    font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
    font-size: 22px;
    line-height: 33px;
    font-weight: 700;
    font-style: normal;
    letter-spacing: 0%;
    vertical-align: middle;

    @media (max-width: 959px) {
        max-width: 320px;
        font-size: 14px;
        line-height: 1.55;
        margin-bottom: 16px;
    }
`

const badgeCss = css`
    display: inline-flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    margin-bottom: 32px;
    border: 1px solid rgba(255, 122, 69, 0.3);
    border-radius: 999px;
    background: rgba(255, 237, 230, 0.6);
    box-shadow: none;
    color: #ff7a45;

    svg {
        font-size: 28px;
        color: #ff7a45;
        opacity: 0.8;
    }

    @media (max-width: 959px) {
        padding: 8px 16px;
        gap: 8px;
        margin-bottom: 16px;
        margin-top: 0;

        svg {
            font-size: 20px;
        }
    }
`

const badgeTextCss = css`
    font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 18px;
    line-height: 17px;
    letter-spacing: 0%;
    vertical-align: middle;

    @media (max-width: 959px) {
        font-size: 13px;
        line-height: 18px;
    }
`

const badgeSmallTextCss = css`
    display: block;
    font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    line-height: 17px;
    letter-spacing: 0%;
    vertical-align: middle;
    margin-top: 2px;
    opacity: 0.85;

    @media (max-width: 959px) {
        font-size: 10px;
        line-height: 14px;
    }
`

const imageColumnCss = css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding-top: 0;
    padding-bottom: 0;
    max-width: 100%;
    width: 100%;
    overflow: visible;

    @media (max-width: 959px) {
        padding-top: 0;
        align-items: flex-start;
    }
`

const imageWrapCss = css`
    position: relative;
    margin-top: 85px;
    max-width: 100%;
    width: 100%;
    margin-bottom: -40px;
    z-index: 0;
    overflow: visible;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (max-width: 959px) {
        width: 100%;
        margin-left: 0;
        margin-right: 0;
        margin-top: 0;
        margin-bottom: -24px;
        padding-bottom: 4px;
    }
`

const imageGlowLeftCss = css`
    position: absolute;
    left: 10px;
    top: 36px;
    width: 190px;
    height: calc(100% - 84px);
    border-radius: 120px 0 0 120px;
    background: linear-gradient(180deg, rgba(181, 240, 214, 0.9) 0%, rgba(181, 240, 214, 0.18) 100%);
    z-index: -1;

    @media (max-width: 959px) {
        display: none;
    }
`

const imageGlowRightCss = css`
    position: absolute;
    right: 0;
    top: -20px;
    width: 280px;
    height: 110%;
    border-radius: 50%;
    background: radial-gradient(circle at center, rgba(132, 230, 200, 0.4) 0%, rgba(181, 240, 214, 0.2) 50%, rgba(181, 240, 214, 0) 100%);
    z-index: -1;
    pointer-events: none;
`

const imageCss = css`
    position: relative;
    z-index: 0;
    display: block;
    width: 100%;
    height: auto;
    border-radius: 140px 180px 160px 140px / 120px 120px 150px 120px;

    @media (max-width: 959px) {
        border-radius: 80px 100px 80px 80px / 60px 60px 80px 60px;
        max-width: 100%;
        margin: 0 auto;
    }
`

const cardWrapCss = css`
    display: flex;
    justify-content: left;
    align-items: flex-start;
    padding-top: 0;
    position: relative;
    z-index: 10;

    @media (max-width: 959px) {
        justify-content: center;
        margin-top: 0;
    }
`

const noteCss = css`
    margin-top: 16px;
    margin-bottom: 24px;
    text-align: left;
    padding: 0;
    max-width: 600px;

    @media (max-width: 959px) {
        margin-top: 16px;
        margin-bottom: 16px;
        text-align: left;
    }
`

const noteTextCss = css`
    color: #64748b;
    font-family: 'DM Sans', 'Helvetica Neue', Arial, sans-serif;
    font-size: 13px;
    line-height: 20.15px;
    font-weight: 600;
    font-style: normal;
    letter-spacing: 0%;
    vertical-align: middle;
    margin: 0;

    @media (max-width: 959px) {
        font-size: 12px;
    }
`

const noteAccentCss = css`
    color: #64748b;
    font-weight: 700;
`


const SimuladorV2Afi = ({
    title,
    subtitle,
    badgeMainText,
    badgeSubText,
    heroImageAlt,
    noteText,
    noteHighlight,
    pageContext
}) => {
    const isMobile = useMediaQuery('(max-width:959px)')

    return (
        <div css={pageCss}>
            <div css={heroCss}>
                <div css={glowTopCss} />
                <div css={glowBottomCss} />

                <Container maxWidth="xl">
                    <Grid container spacing={isMobile ? 0 : 4}>
                        <Grid item xs={12} md={6}>
                            <h1 css={titleCss}>{title}</h1>
                            <p css={subtitleCss}>{subtitle}</p>

                            <div css={noteCss}>
                                <p css={noteTextCss}>
                                    <span css={noteAccentCss}>{noteHighlight}</span> {noteText}
                                </p>
                            </div>

                            {isMobile && (
                                <div css={badgeCss}>
                                    <SecurityOutlinedIcon />
                                    <span css={badgeTextCss}>
                                        {badgeMainText}
                                        <span css={badgeSmallTextCss}>{badgeSubText}</span>
                                    </span>
                                </div>
                            )}

                            <div css={cardWrapCss}>
                                <GreenCard pageContext={pageContext} />
                            </div>

                            {isMobile && (
                                <div css={imageWrapCss} style={{ marginTop: '15px' }}>
                                    <div css={imageGlowLeftCss} />
                                    <div css={imageGlowRightCss} />
                                    <img
                                        src={HeroImage}
                                        alt={heroImageAlt}
                                        css={imageCss}
                                    />
                                </div>
                            )}
                        </Grid>

                        <Grid item xs={12} md={6}>
                            {!isMobile && (
                                <div css={imageColumnCss}>
                                    <div css={badgeCss}>
                                        <SecurityOutlinedIcon />
                                        <span css={badgeTextCss}>
                                            {badgeMainText}
                                            <span css={badgeSmallTextCss}>{badgeSubText}</span>
                                        </span>
                                    </div>
                                    <div css={imageWrapCss}>
                                        <div css={imageGlowRightCss} />
                                        <img
                                            src={HeroImage}
                                            alt={heroImageAlt}
                                            css={imageCss}
                                        />
                                    </div>
                                </div>
                            )}
                        </Grid>
                    </Grid>
                </Container>
            </div>
        </div>
    )
}

SimuladorV2Afi.defaultProps = {
    title: (
        <>
            ¿Necesitas <span css={accentCss}>dinero?</span>
        </>
    ),
    subtitle: '¡Conoce los servicios que te ofrece Apoyo Financiero!',
    badgeMainText: 'Préstamos personales desde $750 hasta $4,000 USD*',
    badgeSubText: '*Sujeto a aprobación de crédito',
    heroImageAlt: 'Familia feliz',
    noteHighlight: 'Toma nota:',
    noteText: 'Nunca te pediremos dinero por adelantado para recibir un préstamo'
}

export default withThemeProps(SimuladorV2Afi, 'VDNPReferidos')
